/**
 * Nova role definitions
 * Centralized source of truth for all role-related constants
 */
export const ROLES = {
  COPYWRITER: "nova_copywriter",
} as const;

export const NOVA_ROLE_PREFIX = "nova_";
